<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >{{data.titulo}}</span
            >
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <div>
            Favor ingrese el informe correspondiente a la OOCC:
            <form
                class="form"
                [formGroup]="formulario"
                autocomplete="off"
                class="mt-16"
            >
                <mat-form-field class="full-width">
                    <ngx-mat-file-input
                        placeholder="Seleccione un archivo"
                        [formControl]="formulario"
                    >
                    </ngx-mat-file-input>
                </mat-form-field>
                <mat-error *ngIf="formulario.errors?.maxSize">
                    El documento no puede ser mayor a {{ maxSize }} MB
                </mat-error>
            </form>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cerrar</button>
        <button
            mat-raised-button
            color="accent"
            [disabled]="!formulario.valid"
            [mat-dialog-close]="formulario.value"
        >
            Guardar
        </button>
    </mat-dialog-actions>
</div>
